/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { createSelector } from '@ngrx/store';
import { GGCCLicenseType } from '@shared/types/license';
import { licenseStatus, targetSelector } from './app.selectors';

export const hasLicenseSelector = createSelector(targetSelector, licenseStatus, (target, licenseStatus) => {
  if (target === 'hosted') return true;
  return (
    licenseStatus?.licenseType === GGCCLicenseType.commercial ||
    licenseStatus?.licenseType === GGCCLicenseType.developer
  );
});
